module.exports = __webpack_public_path__ + "static/img/9.7ae08d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/zh/9.png
// module id = 0jVB
// module chunks = 0